//@ts-nocheck
import React, { useMemo } from "react";
import {
  Delete,
  Edit,
  Save,
  Cancel,
  ArrowDownward,
  ArrowUpward,
  ExpandMore,
} from "@mui/icons-material";
import { Checkbox, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Table, TableBody, TableContainer, TableRow, TableHead, TableCell } from "@mui/material";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";
import { useState } from "react";
import DataTableHeadCell from "./DataTableHeadCell";
import MDTypography from "components/MDTypography";
import { NumericFormat } from "react-number-format";
import { formatMonthYearToInput } from "utils/CalanderUtils";
import moment from "moment-business-days";
import MDSelect from "components/MDSelect";

interface EditableTableProps {
  columns: any[];
  data: any[];
  onDelete: (id: number) => void;
  onEdit: (row: any | null) => void;
  onSave: (row: any) => void;
  onCancel: () => void;
  editingRow: any | null;
  isEditing: boolean;
  onInputChange: (value: string, field: string) => void;
  selectedRows: any[];
  onSelectRow: (rowKey: any) => void;
  onSelectAll: () => void;
  onSort: (columnKey: any) => void;
  getRowStyle(row: any | null);
  isActionsDisabled(row: any | null);
  renderTotal: (rows: any) => any | null;
  rowKey: any;
  totalColumn: any | null;
  renderTotal?: (rows: any) => ReactNode;
  totalColumn?: string | null;
  onAddNewSubmit?: (value: string) => boolean;
}

const EditableTable: React.FC<EditableTableProps> = ({
  columns,
  data,
  onDelete,
  onEdit,
  onSave,
  onCancel,
  editingRow,
  isEditing,
  onInputChange,
  selectedRows,
  onSelectRow,
  onSelectAll,
  onSort,
  getRowStyle,
  isActionsDisabled,
  rowKey,
  renderTotal,
  totalColumn,
  onAddNewSubmit,
}) => {
  const handleCheckboxChange = (rowKey: any) => {
    onSelectRow(rowKey);
  };

  const handleSelectAllChange = () => {
    onSelectAll();
  };

  const [search, setSearch] = useState("");

  const filteredData = data.filter((row) => {
    return columns.some((column) =>
      row[column.accessor]?.toString().toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <>
      <TableContainer sx={{ boxShadow: "none" }}>
        <Table style={{ width: "100%", borderCollapse: "collapse" }}>
          <MDBox component="thead">
            <TableRow>
              <TableCell
                align="center"
                padding="checkbox"
                sx={{ padding: "3px", width: "30px", maxWidth: "30px" }}
              >
                <Checkbox
                  checked={selectedRows.length === filteredData.length}
                  onChange={handleSelectAllChange}
                  color="primary"
                />
              </TableCell>
              {columns.map((column: any) => (
                <DataTableHeadCell
                  key={column.accessor}
                  align={column.align ? column.align : "left"}
                  sx={{ padding: "8px" }}
                >
                  <MDBox
                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                    onClick={() => onSort(column.accessor)}
                  >
                    {column.Header}
                  </MDBox>
                </DataTableHeadCell>
              ))}

             {( onDelete ||  onEdit)  &&
              <DataTableHeadCell
                key={"actions"}
                align={"left"}
                style={{ width: "120px", padding: "8px" }}
              >
                Actions
              </DataTableHeadCell>
              }
            </TableRow>
          </MDBox>

          <TableBody>
            {filteredData
              .filter((row: any) => {
                return !editingRow || editingRow[rowKey] !== row[rowKey];
              })
              .map((row: any) => (
                <TableRow key={row[rowKey]}>
                  <TableCell
                    align="center"
                    padding="checkbox"
                    sx={{ padding: "3px", width: "30px", maxWidth: "30px" }}
                  >
                    <Checkbox
                      checked={selectedRows.includes(row[rowKey])}
                      onChange={() => handleCheckboxChange(row[rowKey])}
                      color="primary"
                    />
                  </TableCell>

                  {columns.map((column: any) => {
                    const cellValue =
                      editingRow && editingRow[column.accessor] ? editingRow[column.accessor] : "";
                    return (
                      <TableCell
                        key={column.accessor}
                        style={{
                          padding: "8px",
                          textAlign: column.align || "center",
                          width: column.width || "auto",
                        }}
                      >
                        <MDBox>
                          {column.Cell ? (
                            <MDTypography fontSize={"0.75rem"} fontWeight={getRowStyle(row)}>
                              {" "}
                              {column.Cell({ row })}
                            </MDTypography>
                          ) : (
                            <MDTypography fontSize={"0.75rem"} fontWeight={getRowStyle(row)}>
                              {" "}
                              {row[column.accessor]}{" "}
                            </MDTypography>
                          )}
                        </MDBox>
                      </TableCell>
                    );
                  })}

                  {(onDelete || onEdit) && 
                    <TableCell align="center" sx={{ padding: "8px" }}>
                    <MDBox display="flex" justifyContent="left" gap={0.5}>
                      <MDButton
                        variant="text"
                        color="error"
                        onClick={() => onDelete(row[rowKey])}
                        startIcon={<Delete />}
                        sx={{ minWidth: "auto", padding: "4px 8px" }}
                        disabled={isActionsDisabled ? isActionsDisabled(row) : false}
                      >
                        Delete
                      </MDButton>
                      <MDButton
                        variant="text"
                        color="secondary"
                        onClick={() => onEdit(row)}
                        disabled={isActionsDisabled ? isActionsDisabled(row) : false}
                        startIcon={<Edit />}
                        sx={{ minWidth: "auto", padding: "4px 8px" }}
                      >
                        Edit
                      </MDButton>
                    </MDBox>
                  </TableCell>
                  }
                </TableRow>
              ))}

            {isEditing && editingRow && (
              <TableRow
                sx={{ height: 100, verticalAlign: "bottom" }}
                key={editingRow[rowKey] || "new"}
              >
                <TableCell align="center" padding="checkbox" sx={{ padding: "2px" }}></TableCell>

                {columns.map((column: any) => {
                  const cellValue = editingRow[column.accessor] || "";

                  return (
                    <TableCell
                      key={column.accessor}
                      style={{
                        padding: "2px",
                        textAlign: column.align || "center",
                        width: column.width || "auto",
                      }}
                    >
                      <MDBox>
                        {column.input === "select" ? (
                          <Select
                            variant="standard"
                            disabled={column?.disabled}
                            label={column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}
                            endAdornment={<ExpandMore />}
                            value={
                              column.selector
                                ? editingRow[column.selector]
                                : column.accessor
                                ? editingRow[column.accessor]
                                : ""
                            }
                            onChange={(e) => {
                              if (column.selector) {
                                onInputChange(e.target.value, column.selector);
                                onInputChange(e.target.label, column.accessor);
                              } else {
                                onInputChange(e.target.value, column.accessor);
                              }
                            }}
                            sx={{
                              "& #funding-calculator-select": {
                                fontSize: 14,
                                fontWeight: 700,
                              },
                              minWidth: 120,
                              maxWidth: column?.width,
                            }}
                          >
                            {column?.options?.map((option: any, idx: number) => (
                              <MenuItem key={idx} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : column.input === "customSelect" ? (
                          <MDSelect
                            label={
                              column?.Header === "Distributions"
                                ? "Broker"
                                : column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                                    char.toUpperCase()
                                  )
                            }
                            disableClearable={true}
                            isAddingNew={editingRow.showAddingNew}
                            newInputValue={editingRow?.newSyndicatorParty}
                            sx={{ minWidth: 120, maxWidth: 300 }}
                            value={
                              column.selector
                                ? column.options?.find(
                                    (opt) => opt.value === editingRow[column.selector]
                                  )
                                : column.accessor
                                ? column.options?.find(
                                    (opt) => opt.value === editingRow[column.accessor]
                                  )
                                : null
                            }
                            options={[...(column.options || [])]}
                            onChange={(selectedOption) => {
                              if (!selectedOption) return;

                              if ((selectedOption as any).isAddNew) {
                                onInputChange(null, "addNew");
                                return;
                              }
                              if (column.selector) {
                                onInputChange(selectedOption.value, column.selector);
                                onInputChange(selectedOption.label, column.accessor);
                              } else {
                                onInputChange(selectedOption.value, column.accessor);
                              }
                            }}
                            placeholder={column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}
                            disabled={column.disabled && column?.disabled()}
                            getOptionLabel={(option) => option.label}
                            addNewOption
                            onAddNewSubmit={(value: any) => {
                              if (onAddNewSubmit) {
                                return onAddNewSubmit(value);
                              } else {
                                return false;
                              }
                            }}
                          />
                        ) : column.input === "amount" ? (
                          <NumericFormat
                            variant="standard"
                            label={column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}
                            value={cellValue || ""}
                            thousandSeparator
                            prefix="$"
                            decimalScale={2}
                            fixedDecimalScale
                            allowNegative={false}
                            customInput={MDInput}
                            error={
                              column.required !== false ? isNaN(cellValue) || cellValue <= 0 : false
                            }
                            disabled={column.disabled && column.disabled()}
                            onValueChange={({ value }) => {
                              const formattedValue = parseFloat(value.replace(/[^0-9.-]+/g, ""));
                              onInputChange(formattedValue, column.accessor);
                            }}
                            inputProps={{
                              style: { fontSize: "0.75rem", fontWeight: 700 },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: "0.7rem",
                              },
                            }}
                            sx={{ flexBasis: "40%" }}
                          />
                        ) : column.input === "number" ? (
                          <MDInput
                            variant="standard"
                            type="number"
                            label={column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}
                            disabled={column.disabled && column.disabled()}
                            value={cellValue || ""}
                            onChange={(e) => onInputChange(e.target.value, column.accessor)}
                            error={
                              column.required !== false ? isNaN(cellValue) || cellValue <= 0 : false
                            }
                            inputProps={{
                              style: { fontSize: "0.75rem", fontWeight: 700 },
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: "0.7rem",
                              },
                            }}
                            sx={{ flexBasis: "33%" }}
                          />
                        ) : column.input === "checkbox" ? (
                          <Checkbox
                            checked={!!cellValue}
                            disabled={column.disabled && column.disabled()}
                            onChange={(e) => onInputChange(e.target.checked, column.accessor)}
                            sx={{ fontSize: 20 }}
                          />
                        ) : column.input === "monthYear" ? (
                          <MDInput
                            variant="standard"
                            type="month"
                            value={formatMonthYearToInput(editingRow[column.accessor])}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (!value) {
                                onInputChange("", column.accessor);
                                return;
                              }
                              const dt = moment(value, "YYYY-MM", true);
                              if (dt.isValid()) {
                                const formatted = dt.format("MMMM YYYY");
                                onInputChange(formatted, column.accessor);
                              } else {
                                onInputChange("", column.accessor);
                              }
                            }}
                            sx={{ fontSize: "0.75rem", fontWeight: 700 }}
                            inputProps={{
                              style: { fontSize: "0.75rem", fontWeight: 700 },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: "0.7rem",
                              },
                            }}
                          />
                        ) : column.input === "date" ? (
                          <MDInput
                            variant="standard"
                            type="date"
                            value={editingRow[column.accessor] || ""}
                            onChange={(e) => onInputChange(e.target.value, column.accessor)}
                            sx={{ fontSize: "0.75rem", fontWeight: 700 }}
                            inputProps={{
                              style: { fontSize: "0.75rem", fontWeight: 700 },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: "0.7rem",
                              },
                            }}
                          />
                        ) : (
                          <MDInput
                            variant="standard"
                            disabled={column.disabled && column.disabled()}
                            label={column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}
                            value={cellValue || ""}
                            onChange={(e) => onInputChange(e.target.value, column.accessor)}
                            error={column.required !== false ? !cellValue : false}
                            InputLabelProps={{
                              sx: {
                                fontSize: "0.7rem",
                              },
                            }}
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 700,
                            }}
                          />
                        )}
                      </MDBox>
                    </TableCell>
                  );
                })}

                <TableCell align="center" sx={{ padding: "8px" }}>
                  <MDBox display="flex" justifyContent="center" gap={0.5}>
                    <MDButton
                      variant="text"
                      color="primary"
                      onClick={() => onSave(editingRow)}
                      startIcon={<Save />}
                      sx={{ minWidth: "auto", padding: "4px 8px" }}
                    >
                      Save
                    </MDButton>
                    <MDButton
                      variant="text"
                      color="secondary"
                      onClick={onCancel}
                      startIcon={<Cancel />}
                      sx={{ minWidth: "auto", padding: "4px 8px" }}
                    >
                      Cancel
                    </MDButton>
                  </MDBox>
                </TableCell>
              </TableRow>
            )}

            {renderTotal && (
              <TableRow key="totals">
                <TableCell></TableCell>
                <TableCell align="left" fontSize={"0.75rem"} fontWeight={"bold"}>
                  <MDTypography fontSize={"0.75rem"} fontWeight={"bold"}>
                    TOTAL:
                  </MDTypography>
                </TableCell>

                {columns.map((column, index) => {
                  if (index < 1) return;
                  if (totalColumn.includes(column.accessor)) {
                    return (
                      <TableCell key={column.accessor} sx={{ padding: "8px" }} align="left">
                        <MDTypography fontSize={"0.75rem"} fontWeight={"bold"}>
                          {renderTotal(column.accessor)}
                        </MDTypography>
                      </TableCell>
                    );
                  } else {
                    return (
                      <TableCell key={column.accessor} sx={{ padding: "8px" }}>
                        <MDTypography fontSize={"0.75rem"} fontWeight={700}></MDTypography>
                      </TableCell>
                    );
                  }
                })}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default EditableTable;
